import { Flex } from '@chakra-ui/react'
import React from 'react'

export const Title = ({ children, ...props }) => {
  return (
    <Flex fontSize="12px" bgColor="#F5F8FB" py={'6px'} alignItems="center" justifyContent="center" {...props}>
      {children}
    </Flex>
  )
}
